import { useRef, useState, useEffect, useContext } from 'react'
import { useNavigate, redirect } from 'react-router-dom'
import axios from 'axios'
import $ from 'jquery'
import Header from './Header';
import Footer from './Footer';

const MGs = () => {
  const server_app_api = window.SERVER_APP_API
  const server_app_api_php = window.SERVER_APP_API_PHP

  let [handleLoader, setHandleLoader] = useState('')
  const [DBView, setDBView] = useState([])
  const [viewMode, setViewMode] = useState('grid'); // 'grid' or 'table'
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(12);
  const [totalPages, setTotalPages] = useState(1);

  useEffect(() => {
    setHandleLoader('Loading')
    var formData = new FormData()
    formData.append('apiType', 'getViewMasterGuides')
    axios({
      method: 'post',
      url: `${server_app_api_php}/server/index.php`,
      data: formData,
      headers: { 'Content-Type': 'multipart/form-data' }
    }).then(response => {
      setHandleLoader('')
      setDBView(response.data)
    })
  }, [])

  // Calculate pagination when DBView or itemsPerPage changes
  useEffect(() => {
    const total = Math.ceil(DBView.length / itemsPerPage);
    setTotalPages(total);
    // Reset to page 1 if current page exceeds total pages
    if (currentPage > total && total > 0) {
      setCurrentPage(1);
    }
  }, [DBView, itemsPerPage, currentPage]);

  // Pagination
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = DBView.slice(indexOfFirstItem, indexOfLastItem);

  // Handle items per page change
  const handleItemsPerPageChange = (e) => {
    const value = parseInt(e.target.value);
    setItemsPerPage(value);
    setCurrentPage(1); // Reset to first page
  };

  // Generate page numbers
  const getPageNumbers = () => {
    const pageNumbers = [];
    const maxVisiblePages = 5;
    
    if (totalPages <= maxVisiblePages) {
      for (let i = 1; i <= totalPages; i++) {
        pageNumbers.push(i);
      }
    } else {
      if (currentPage <= 3) {
        for (let i = 1; i <= 4; i++) pageNumbers.push(i);
        pageNumbers.push('...');
        pageNumbers.push(totalPages);
      } else if (currentPage >= totalPages - 2) {
        pageNumbers.push(1);
        pageNumbers.push('...');
        for (let i = totalPages - 3; i <= totalPages; i++) pageNumbers.push(i);
      } else {
        pageNumbers.push(1);
        pageNumbers.push('...');
        for (let i = currentPage - 1; i <= currentPage + 1; i++) pageNumbers.push(i);
        pageNumbers.push('...');
        pageNumbers.push(totalPages);
      }
    }
    
    return pageNumbers;
  };

  return (
    <>
      <div className="min-h-screen bg-gradient-to-b from-amber-50 to-orange-50">
        <Header />
        
        <main className="pt-24">
          <div className="max-w-7xl mx-auto px-4 py-8">
            {/* Header */}
            <div className="text-center mb-12">
              <h1 className="text-4xl font-bold text-gray-800 mb-4">Invested Master Guides</h1>
              <p className="text-gray-600 max-w-2xl mx-auto">
                Meet our dedicated Master Guides who serve and lead in our youth ministries.
              </p>
            </div>

            {/* Loading State */}
            {handleLoader === 'Loading' ? (
              <div className="flex flex-col items-center justify-center py-20">
                <div className="w-16 h-16 border-4 border-amber-500 border-t-transparent rounded-full animate-spin mb-4"></div>
                <p className="text-gray-600">Loading Master Guides...</p>
              </div>
            ) : (
              <>
                {/* View Toggle and Controls */}
                <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-8 gap-4">
                  <div className="text-gray-700">
                    <span className="font-semibold">{DBView.length}</span> Master Guides
                  </div>
                  
                  <div className="flex flex-col sm:flex-row gap-4">
                    {/* Items per page selector */}
                    <div className="flex items-center space-x-2">
                      <label className="text-sm text-gray-600">Show:</label>
                      <select 
                        value={itemsPerPage}
                        onChange={handleItemsPerPageChange}
                        className="px-3 py-2 border border-gray-300 rounded-lg bg-white text-gray-700 focus:outline-none focus:ring-2 focus:ring-amber-500 focus:border-transparent"
                      >
                        <option value="6">6</option>
                        <option value="12">12</option>
                        <option value="24">24</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                      </select>
                      <span className="text-sm text-gray-600">per page</span>
                    </div>
                    
                    {/* View toggle buttons */}
                    <div className="flex space-x-2">
                      <button
                        onClick={() => setViewMode('grid')}
                        className={`px-4 py-2 rounded-lg flex items-center space-x-2 ${
                          viewMode === 'grid' 
                            ? 'bg-amber-500 text-white' 
                            : 'bg-white text-gray-700 hover:bg-gray-50'
                        } transition-all duration-300`}
                      >
                        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                          <path d="M4 11h5V5H4v6zm0 7h5v-6H4v6zm6 0h5v-6h-5v6zm6 0h5v-6h-5v6zm-6-7h5V5h-5v6zm6-6v6h5V5h-5z"/>
                        </svg>
                        <span>Grid</span>
                      </button>
                      
                      <button
                        onClick={() => setViewMode('table')}
                        className={`px-4 py-2 rounded-lg flex items-center space-x-2 ${
                          viewMode === 'table' 
                            ? 'bg-amber-500 text-white' 
                            : 'bg-white text-gray-700 hover:bg-gray-50'
                        } transition-all duration-300`}
                      >
                        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                          <path d="M3 13h8V3H3v10zm0 8h8v-6H3v6zm10 0h8V11h-8v10zm0-18v6h8V3h-8z"/>
                        </svg>
                        <span>Table</span>
                      </button>
                    </div>
                  </div>
                </div>

                {/* Grid View */}
                {viewMode === 'grid' && (
                  <div className="grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 mb-8">
                    {currentItems.map((guide, idx) => (
                      <div key={idx} className="bg-white rounded-2xl shadow-lg overflow-hidden transform hover:-translate-y-2 transition-all duration-300 group">
                        {/* Card Header */}
                        <div className="bg-gradient-to-r from-amber-500 to-orange-500 px-4 py-3">
                          <h3 className="text-lg font-bold text-white text-center truncate">
                            {guide.Name}
                          </h3>
                        </div>
                        
                        {/* Card Body */}
                        <div className="p-5">
                          <div className="space-y-3">
                            <div className="flex items-start">
                              <svg className="w-5 h-5 text-amber-500 mt-1 mr-2" fill="currentColor" viewBox="0 0 24 24">
                                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
                              </svg>
                              <div>
                                <p className="text-xs text-gray-500">Investing Pastor</p>
                                <p className="font-medium text-gray-800">{guide.stateTheInvestingPastor}</p>
                              </div>
                            </div>
                            
                            <div className="flex items-start">
                              <svg className="w-5 h-5 text-amber-500 mt-1 mr-2" fill="currentColor" viewBox="0 0 24 24">
                                <path d="M9 11H7v2h2v-2zm4 0h-2v2h2v-2zm4 0h-2v2h2v-2zm2-7h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V9h14v11z"/>
                              </svg>
                              <div>
                                <p className="text-xs text-gray-500">Year Invested</p>
                                <p className="font-medium text-gray-800">{guide.stateTheYearYouWereInvestedMg}</p>
                              </div>
                            </div>
                            
                            <div className="flex items-start">
                              <svg className="w-5 h-5 text-amber-500 mt-1 mr-2" fill="currentColor" viewBox="0 0 24 24">
                                <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/>
                              </svg>
                              <div>
                                <p className="text-xs text-gray-500">Current District</p>
                                <p className="font-medium text-gray-800">{guide.district}</p>
                              </div>
                            </div>
                            
                            <div className="flex items-start">
                              <svg className="w-5 h-5 text-amber-500 mt-1 mr-2" fill="currentColor" viewBox="0 0 24 24">
                                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
                              </svg>
                              <div>
                                <p className="text-xs text-gray-500">Current Church</p>
                                <p className="font-medium text-gray-800">{guide.church}</p>
                              </div>
                            </div>
                          </div>
                          
                          {/* Action Button */}
                          <button className="w-full mt-4 bg-gradient-to-r from-amber-50 to-orange-50 text-amber-700 py-2 rounded-lg font-semibold hover:from-amber-100 hover:to-orange-100 transition-all duration-300">
                            View Profile
                          </button>
                        </div>
                      </div>
                    ))}
                  </div>
                )}

                {/* Table View */}
                {viewMode === 'table' && (
                  <div className="bg-white rounded-2xl shadow-lg overflow-hidden mb-8">
                    <div className="overflow-x-auto">
                      <table className="w-full">
                        <thead>
                          <tr className="bg-gradient-to-r from-amber-500 to-orange-500 text-white">
                            <th className="py-3 px-4 text-left font-semibold">S/N</th>
                            <th className="py-3 px-4 text-left font-semibold">Name</th>
                            <th className="py-3 px-4 text-left font-semibold">Year Invested</th>
                            <th className="py-3 px-4 text-left font-semibold">Investing Pastor</th>
                            <th className="py-3 px-4 text-left font-semibold">District</th>
                            <th className="py-3 px-4 text-left font-semibold">Church</th>
                          </tr>
                        </thead>
                        <tbody>
                          {currentItems.map((guide, idx) => (
                            <tr key={idx} className="border-b border-gray-200 hover:bg-amber-50 transition-colors duration-300">
                              <td className="py-3 px-4 text-gray-700">{idx + 1 + (currentPage - 1) * itemsPerPage}</td>
                              <td className="py-3 px-4">
                                <div className="font-medium text-gray-800">{guide.Name}</div>
                              </td>
                              <td className="py-3 px-4">
                                <div className="inline-flex items-center bg-amber-100 text-amber-800 px-3 py-1 rounded-full text-sm">
                                  {guide.stateTheYearYouWereInvestedMg}
                                </div>
                              </td>
                              <td className="py-3 px-4 text-gray-600">{guide.stateTheInvestingPastor}</td>
                              <td className="py-3 px-4 text-gray-600">{guide.district}</td>
                              <td className="py-3 px-4 text-gray-600">{guide.church}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                )}

                {/* Pagination */}
                {DBView.length > 0 && totalPages > 1 && (
                  <div className="flex flex-col sm:flex-row justify-between items-center mt-8 gap-4">
                    <div className="text-sm text-gray-600">
                      Showing <span className="font-semibold">{indexOfFirstItem + 1}</span> to <span className="font-semibold">
                        {Math.min(indexOfLastItem, DBView.length)}
                      </span> of <span className="font-semibold">{DBView.length}</span> entries
                    </div>
                    
                    <div className="flex items-center space-x-2">
                      <button
                        onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                        disabled={currentPage === 1}
                        className="px-4 py-2 rounded-lg bg-white text-gray-700 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-300 flex items-center space-x-1"
                      >
                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                        </svg>
                        <span>Previous</span>
                      </button>
                      
                      <div className="flex space-x-1">
                        {getPageNumbers().map((pageNum, idx) => (
                          pageNum === '...' ? (
                            <span key={`ellipsis-${idx}`} className="px-3 py-2 text-gray-500">...</span>
                          ) : (
                            <button
                              key={pageNum}
                              onClick={() => setCurrentPage(pageNum)}
                              className={`w-10 h-10 rounded-lg ${
                                currentPage === pageNum
                                  ? 'bg-amber-500 text-white'
                                  : 'bg-white text-gray-700 hover:bg-gray-50'
                              } transition-all duration-300`}
                            >
                              {pageNum}
                            </button>
                          )
                        ))}
                      </div>
                      
                      <button
                        onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                        disabled={currentPage === totalPages}
                        className="px-4 py-2 rounded-lg bg-white text-gray-700 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-300 flex items-center space-x-1"
                      >
                        <span>Next</span>
                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                        </svg>
                      </button>
                    </div>
                  </div>
                )}

                {/* Stats */}
                <div className="bg-gradient-to-r from-amber-600 to-orange-600 rounded-2xl p-8 text-white mt-8">
                  <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
                    <div className="text-center">
                      <div className="text-3xl font-bold mb-2">{DBView.length}</div>
                      <div className="text-amber-100">Total Master Guides</div>
                    </div>
                    <div className="text-center" hidden>
                      <div className="text-3xl font-bold mb-2">
                        {new Set(DBView.map(g => g.stateTheYearYouWereInvestedMg)).size}
                      </div>
                      <div className="text-amber-100">Years of Investment</div>
                    </div>
                    <div className="text-center" hidden>
                      <div className="text-3xl font-bold mb-2">
                        {new Set(DBView.map(g => g.district)).size}
                      </div>
                      <div className="text-amber-100">Districts</div>
                    </div>
                    <div className="text-center" hidden>
                      <div className="text-3xl font-bold mb-2">
                        {new Set(DBView.map(g => g.church)).size}
                      </div>
                      <div className="text-amber-100">Churches</div>
                    </div>
                  </div>
                </div>

                {/* About Master Guides */}
                <div className="mt-12 bg-white rounded-2xl shadow-lg p-8" hidden>
                  <h3 className="text-2xl font-bold text-gray-800 mb-6">About Master Guides</h3>
                  
                  <div className="grid md:grid-cols-2 gap-8">
                    <div className="space-y-4">
                      <p className="text-gray-600 leading-relaxed">
                        Master Guides are dedicated youth leaders who have completed advanced training in youth ministry, 
                        spiritual leadership, and outdoor education. They play a crucial role in mentoring and guiding 
                        our young people.
                      </p>
                      
                      <div className="bg-gradient-to-r from-amber-50 to-orange-50 rounded-xl p-4">
                        <h4 className="font-semibold text-gray-800 mb-2">Training Includes:</h4>
                        <ul className="space-y-2">
                          <li className="flex items-center">
                            <div className="w-2 h-2 bg-amber-500 rounded-full mr-2"></div>
                            <span className="text-gray-600">Youth Ministry Principles</span>
                          </li>
                          <li className="flex items-center">
                            <div className="w-2 h-2 bg-amber-500 rounded-full mr-2"></div>
                            <span className="text-gray-600">Spiritual Leadership</span>
                          </li>
                          <li className="flex items-center">
                            <div className="w-2 h-2 bg-amber-500 rounded-full mr-2"></div>
                            <span className="text-gray-600">Outdoor Education</span>
                          </li>
                          <li className="flex items-center">
                            <div className="w-2 h-2 bg-amber-500 rounded-full mr-2"></div>
                            <span className="text-gray-600">Mentoring Skills</span>
                          </li>
                        </ul>
                      </div>
                    </div>
                    
                    <div className="space-y-4">
                      <div className="bg-gradient-to-r from-blue-50 to-cyan-50 rounded-xl p-4">
                        <h4 className="font-semibold text-gray-800 mb-2">Become a Master Guide</h4>
                        <p className="text-gray-600 text-sm mb-4">
                          Interested in becoming a Master Guide? Join our next training session.
                        </p>
                        <button className="bg-gradient-to-r from-blue-500 to-cyan-500 text-white px-4 py-2 rounded-lg hover:from-blue-600 hover:to-cyan-600 transition-all duration-300">
                          Learn More
                        </button>
                      </div>
                      
                      <div className="bg-gradient-to-r from-purple-50 to-pink-50 rounded-xl p-4">
                        <h4 className="font-semibold text-gray-800 mb-2">Need a Master Guide?</h4>
                        <p className="text-gray-600 text-sm mb-4">
                          Looking for a Master Guide for your church or event? Contact us for assistance.
                        </p>
                        <button className="bg-gradient-to-r from-purple-500 to-pink-500 text-white px-4 py-2 rounded-lg hover:from-purple-600 hover:to-pink-600 transition-all duration-300">
                          Contact Us
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        </main>

        <Footer />
      </div>
    </>
  )
}

export default MGs